module.exports = __webpack_public_path__ + "media/images/pc/stores/common/instagram/photographer_sns_02-ca1e3eb709051e76574754b717b65ca8.jpg";